// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://d51ekulg32.execute-api.us-east-2.amazonaws.com/development/",
  // fileUploadUrl: "https://9a0ltixa28.execute-api.us-east-2.amazonaws.com/",
  fileUploadUrl: "https://vqhynha6k6.execute-api.us-east-1.amazonaws.com/",
  // fileUploadUrl: "http://localhost:3000/dev/",
  mandatorySignIn: false,
  // Cognito pool that actually holds the users -- the same pool the API authenticates against
  // (COGNITO_USER_POOL_ID in env.dev.json). Forgot-password and resendCode used to point at the
  // 2021 us-east-2 pool, which no longer has these users. No identity pool exists in us-east-1,
  // and none is needed: nothing in the app asks Amplify for AWS credentials.
  region: "us-east-1",
  userPoolId: "us-east-1_VnpMhqhoo",
  userPoolWebClientId: "2dmqqva69cika53al2ld9nt0ql",
  storage: sessionStorage,

  // baseUrl2: "https://fg5zt0v3dg.execute-api.us-east-1.amazonaws.com/dev/"
  // baseUrl2: "https://uladgbqc9k.execute-api.us-east-1.amazonaws.com/dev/"
  // baseUrl2: "https://2tfycfenlk.execute-api.us-east-1.amazonaws.com/dev/"
  baseUrl2: "https://avlsgvbq02.execute-api.us-east-1.amazonaws.com/dev/",
  appsyncGraphQLEndpoint: "https://wc5vkfmbo5dwjcmutwor7hzkzi.appsync-api.us-east-1.amazonaws.com/graphql",
  appsyncRegion: "us-east-1",
  apiKey: "da2-dhpt2ypcwjdhbhwn7hikvgaqsm",
  // baseUrl2: "http://localhost:3000/dev/"

  posthogKey: "phc_wZCoFPuqShauPhet2BZepXderj2AiwcTJoGFCe7BvRHN",
  posthogHost: "https://us.i.posthog.com",
  analyticsEnabled: true,

  // production: false,
  // baseUrl : "https://d51ekulg32.execute-api.us-east-2.amazonaws.com/development/",
  // mandatorySignIn: false,
  // region: "us-east-2",
  // userPoolId: "us-east-2_RZY4M8oAT",
  // identityPoolId: "us-east-2:b0999cc8-be45-4fd4-9460-48c5fc93e926",
  // userPoolWebClientId: "ko7skda3si5adhlephv4orv5d",
  // storage: sessionStorage,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
